import Image1 from "../src/images/Sosyal/deniz-sosyal.jpg"
import Image2 from "../src/images/Sosyal/leo-sunum.jpg"
import Image3 from "../src/images/Sosyal/oggi.jpg"
import Image4 from "../src/images/Sosyal/pluskim.jpg"
import Image5 from "../src/images/Sosyal/vespa.jpg"
import Image6 from "../src/images/Web/buger.jpg"
import Image7 from "../src/images/Web/deniz-kitapevi.jpg"
import Image8 from "../src/images/Web/k2banner.jpg"
import Image9 from "../src/images/Web/minio.jpg"
import Image10 from "../src/images/Web/olva-ambalaj-web.jpg"

import ImageMıx from "../src/images/Mix/mix1.jpg"
import ImageMıx2 from "../src/images/Mix/mix2.jpg"
import ImageMıx3 from "../src/images/Mix/minio-kapak.jpg"
import ImageMıx4 from "../src/images/Mix/oggi2.jpg"
import ImageMıx5 from "../src/images/Mix/olva-kapak.jpg"
import ImageMıx6 from "../src/images/Mix/selvi-kapak.jpg"
import ImageMıx7 from "../src/images/Mix/sport.jpg"
import ImageMıx8 from "../src/images/Mix/urmak-kapak.jpg"

import ImageGrafik1 from "../src/images/Grafik-Tasarim/afis.jpg"
import ImageGrafik2 from "../src/images/Grafik-Tasarim/katalog.jpg"
import ImageGrafik3 from "../src/images/Grafik-Tasarim/chem.jpg"
import ImageGrafik4 from "../src/images/Grafik-Tasarim/dvd.jpg"
import ImageGrafik5 from "../src/images/Grafik-Tasarim/katalog-urmak.jpg"
import ImageGrafik6 from "../src/images/Grafik-Tasarim/billboard.jpg"
import ImageGrafik7 from "../src/images/Grafik-Tasarim/perge.jpg"
import ImageGrafik8 from "../src/images/Grafik-Tasarim/plus.jpg"
import ImageGrafik9 from "../src/images/Grafik-Tasarim/pluskim-dergi.jpg"
import ImageGrafik10 from "../src/images/Grafik-Tasarim/sadem.jpg"

import ImageLogo1 from "../src/images/Logo/logo1.jpg"
import ImageLogo2 from "../src/images/Logo/logo2.jpg"
import ImageLogo3 from "../src/images/Logo/logo3.jpg"
import ImageLogo4 from "../src/images/Logo/logo4.jpg"

import ImageBrandingHealtea1 from "../src/images/Branding/HEALTEA/healtea1.jpg"
import ImageBrandingHealtea2 from "../src/images/Branding/HEALTEA/healtea2.jpg"
import ImageBrandingHealtea3 from "../src/images/Branding/HEALTEA/healtea3.jpg"
import ImageBrandingGastronovas1 from "../src/images/Branding/INOVAS-GASTRONOVAS/gastronovas1.jpg"
import ImageBrandingGastronovas2 from "../src/images/Branding/INOVAS-GASTRONOVAS/gastronovas2.jpg"
import ImageBrandingInovas1 from "../src/images/Branding/INOVAS-GASTRONOVAS/inovas1.jpg"
import ImageBrandingInovas2 from "../src/images/Branding/INOVAS-GASTRONOVAS/inovas2.jpg"
import ImageBrandingMinio1 from "../src/images/Branding/MINIO/minio1.jpg"
import ImageBrandingMinio2 from "../src/images/Branding/MINIO/minio2.jpg"
import ImageBrandingMinio3 from "../src/images/Branding/MINIO/minio3.jpg"
import ImageBrandingOggi1 from "../src/images/Branding/OGGI/oggi1.jpg"
import ImageBrandingOggi2 from "../src/images/Branding/OGGI/oggi2.jpg"
import ImageBrandingOggi3 from "../src/images/Branding/OGGI/oggi3.jpg"
import ImageBrandingOggi4 from "../src/images/Branding/OGGI/oggi4.jpg"
import ImageBrandingOggi5 from "../src/images/Branding/OGGI/oggi5.jpg"
import ImageBrandingOlva1 from "../src/images/Branding/OLVA/olva1.jpg"
import ImageBrandingOlva2 from "../src/images/Branding/OLVA/olva2.jpg"
import ImageBrandingOlva3 from "../src/images/Branding/OLVA/olva3.jpg"
import ImageBrandingSadem1 from "../src/images/Branding/SADEM/sadem1.jpg"
import ImageBrandingSadem2 from "../src/images/Branding/SADEM/sadem2.jpg"
import ImageBrandingSadem3 from "../src/images/Branding/SADEM/sadem3.jpg"








export const Branding = [
  {
    id: 1,
    img: ImageBrandingHealtea1,
    subCategory: "healtea",
  },
  {
    id: 2,
    img: ImageBrandingHealtea2,
    subCategory: "healtea",
  },
  {
    id: 3,
    img: ImageBrandingHealtea3,
    subCategory: "healtea",
  },
  {
    id: 4,
    img: ImageBrandingGastronovas1,
    subCategory: "inovas",
  },
  {
    id: 5,
    img: ImageBrandingGastronovas2,
    subCategory: "inovas",
  },
  {
    id: 6,
    img: ImageBrandingInovas1,
    subCategory: "inovas",
  },
  {
    id: 7,
    img: ImageBrandingInovas2,
    subCategory: "inovas",
  },
  {
    id: 8,
    img: ImageBrandingMinio1,
    subCategory: "minio",
  },
  {
    id: 9,
    img: ImageBrandingMinio2,
    subCategory: "minio",
  },
  {
    id: 10,
    img: ImageBrandingMinio3,
    subCategory: "minio",
  },
  {
    id: 11,
    img: ImageBrandingOggi1,
    subCategory: "oggi",
  },
  {
    id: 12,
    img: ImageBrandingOggi2,
    subCategory: "oggi",
  },
  {
    id: 13,
    img: ImageBrandingOggi3,
    subCategory: "oggi",
  },
  {
    id: 14,
    img: ImageBrandingOggi4,
    subCategory: "oggi",
  },
  {
    id: 15,
    img: ImageBrandingOggi5,
    subCategory: "oggi",
  },
  {
    id: 16,
    img: ImageBrandingOlva1,
    subCategory: "olva",
  },
  {
    id: 17,
    img: ImageBrandingOlva2,
    subCategory: "olva",
  },
  {
    id: 18,
    img: ImageBrandingOlva3,
    subCategory: "olva",
  },
  {
    id: 19,
    img: ImageBrandingSadem1,
    subCategory: "sadem",
  },
  {
    id: 20,
    img: ImageBrandingSadem2,
    subCategory: "sadem",
  },
  {
    id: 21,
    img: ImageBrandingSadem3,
    subCategory: "sadem",
  },


 
];
export const webPortfolio = [
  {
    id: 1,
    img: Image6,
    subCategory: "web",
  },

  {
    id: 2,
    img: Image7,
    subCategory: "web",
  },
  {
    id: 3,
    img: Image8,
    subCategory: "web",
  },

  {
    id: 4,
    img: Image9,
    subCategory: "web",
  },

  {
    id: 5,
    img: Image10,
    subCategory: "web",
  },
];

export const Tumu = [
  {
    id: 1,
    img: ImageMıx,
    subCategory: "mix",
  },
  {
    id: 2,
    img: ImageMıx2,
    subCategory: "mix",
  },
  {
    id: 3,
    img: ImageMıx3,
    subCategory: "mix",
  },
  {
    id: 4,
    img: ImageMıx4,
    subCategory: "mix",
  },
  {
    id: 5,
    img: ImageMıx5,
    subCategory: "mix",
  },
  {
    id: 6,
    img: ImageMıx6,
    subCategory: "mix",
  },
  {
    id: 7,
    img: ImageMıx7,
    subCategory: "mix",
  },
  {
    id: 8,
    img: ImageMıx8,
    subCategory: "mix",
  },

  
];

export const Sosyal = [
  {
    id: 1,
    img: Image1,
    subCategory: "sosyal",
  },
  {
    id: 2,
    img: Image2,
    subCategory: "sosyal",
  },
  {
    id: 3,
    img: Image3,
    subCategory: "sosyal",
  },
  {
    id: 4,
    img: Image4,
    subCategory: "sosyal",
  },
  {
    id: 5,
    img: Image5,
    subCategory: "sosyal",
  },
];

export const Grafik = [
  {
    id: 1,
    img: ImageGrafik1,
    subCategory: "grafik",
  },
  {
    id: 2,
    img: ImageGrafik2,
    subCategory: "grafik",
  },
  {
    id: 3,
    img: ImageGrafik3,
    subCategory: "grafik",
  },
  {
    id: 4,
    img: ImageGrafik4,
    subCategory: "grafik",
  },
  {
    id: 5,
    img: ImageGrafik5,
    subCategory: "grafik",
  },
  {
    id: 6,
    img: ImageGrafik6,
    subCategory: "grafik",
  },
  {
    id: 7,
    img: ImageGrafik7,
    subCategory: "grafik",
  },
  {
    id: 8,
    img: ImageGrafik8,
    subCategory: "grafik",
  },
  {
    id: 9,
    img: ImageGrafik9,
    subCategory: "grafik",
  },
  {
    id: 10,
    img: ImageGrafik10,
    subCategory: "grafik",
  },
];

export const Logo = [
  {
    id: 1,
    img: ImageLogo1,
    subCategory: "logo",
  },

  {
    id: 2,
    img: ImageLogo2,
    subCategory: "logo",
  },
  {
    id: 3,
    img: ImageLogo3,
    subCategory: "logo",
  },

  {
    id: 4,
    img: ImageLogo4,
    subCategory: "logo",
  },
];




